<div class="group">
  <label>{{ 'postal_code.input.label' | translate }}</label>
  <input
    data-testid="postal-code"
    [formControl]="postalcodeControl"
    type="text"
    placeholder="{{ 'postal_code.input.placeholder' | translate }}"
    class="quantum-input"
    [ngClass]="postalcodeControl.invalid ? 'invalid' : ''"
  />
  <div
    *ngIf="
      postalcodeControl.invalid &&
      postalcodeControl.errors &&
      postalcodeControl.dirty
    "
    [class.dirty]="postalcodeControl.dirty"
    class="error-message"
  >
    <div *ngIf="postalcodeControl.errors['required']">
      {{ 'postal_code.input.required' | translate }}
    </div>
  </div>
</div>
